document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-quote-form]').forEach((wrapper) => {
    const radios = wrapper.querySelectorAll('input[name="contact[Has 3D file]"], input[name="hasFile"]');
    const upload = wrapper.querySelector('[data-upload-section]');
    const description = wrapper.querySelector('[data-description-section]');
    const fileInput = wrapper.querySelector('input[type="file"]');
    const descriptionInput = wrapper.querySelector('[data-project-description]');

    const update = () => {
      const checked = [...radios].find((r) => r.checked);
      if (!checked) return;
      const hasFile = checked.value === 'Yes';
      if (upload) upload.classList.toggle('v3d-hidden', !hasFile);
      if (description) description.classList.toggle('v3d-hidden', hasFile);
      if (fileInput && !fileInput.disabled) fileInput.required = hasFile;
      if (descriptionInput) descriptionInput.required = !hasFile;
    };

    radios.forEach((radio) => radio.addEventListener('change', update));
    update();
  });
});
